<header class="content-header">
  <h4 #trigger class="vision-h4">{{ cloneView ? 'Clone' : ''}}
    {{ data.taskRow.taskId }}</h4>
  <fw-popover [trigger]="trigger" position="below" action="mouseenter">
    <div class="padding-15">
      <div class="task-definition" *ngIf="taskDetails; else loadingDetails">
        <strong class="title">Task {{ taskDetails.reader_task.item_number }} /
          {{ taskDetails.reader_task.batch_total_tasks }}</strong>
        <strong>Container Filter</strong>
        <div class="tags-group">
          <span>Contains tag(s)</span>
          <fw-tags *ngIf="taskTagContainers.include.tags.length > 0; else emptyTags" test-id="task-includes-tags"
            [useAsInlineField]="true" [container]="$any(taskTagContainers.include)" [writable]="false">
          </fw-tags>
        </div>
        <div class="tags-group">
          <span>Does NOT contain tag(s)</span>
          <fw-tags *ngIf="taskTagContainers.exclude.tags.length > 0; else emptyTags" test-id="task-excludes-tags"
            [useAsInlineField]="true" [container]="$any(taskTagContainers.exclude)" [writable]="false">
          </fw-tags>
        </div>
        <ng-template #emptyTags>
          <span><i>None</i></span>
        </ng-template>
      </div>
      <ng-template #loadingDetails>
        <span>Loading...</span>
      </ng-template>
    </div>
  </fw-popover>
  <span test-id="project-context" class="project-context">
    {{"Project" | titlecase }}: {{ data.taskRow.projectLabel }}
  </span>
  <mat-icon *ngIf='canDownloadFiles' (click)='$event.stopPropagation(); downloadTaskFiles(data.taskRow)'
    fwTooltip="Download Associated File">cloud_download
  </mat-icon>
  <button *ngIf="!cloneView" test-id="view-task" mat-flat-button color="primary"
    (click)="viewTask()">Launch In Viewer</button>
</header>
<div mat-dialog-content>
  <div class="immutable-details fw-well">
    <div class="detail">
      <span class="title">Task Type</span>
      <span test-id="task-type" class="detail-value">{{ data.taskRow.taskType }}</span>
    </div>
    <div class="detail">
      <span class="title">Read Protocol</span>
      <span *ngIf="data.taskRow.protocol; else noProtocol" test-id="read-protocol" class="detail-value"
        [fwTooltip]="data.taskRow.protocol?.description">
        {{ data.taskRow.protocol.label }}
      </span>
      <ng-template #noProtocol>
        <span test-id="no-protocol" class="detail-value">None</span>
      </ng-template>
    </div>
    <div class="detail">
      <span class="title">Container</span>
      <fw-ellipsis test-id="container" class="detail-value" [text]="data.taskRow.container.label || ''"
        [tooltip]="data.taskRow.container.hierarchy">
      </fw-ellipsis>
    </div>
    <div *ngIf="!cloneView" class="detail">
      <span class="title">Task Creator</span>
      <span test-id="creator" class="detail-value">
        <ng-container *ngIf="data.taskRow.creator; else unknown">
          <app-avatar [users]="data.taskRow.creator"></app-avatar>
          <span>{{ data.taskRow.creator.firstname }} {{ data.taskRow.creator.lastname }}</span>
        </ng-container>
        <ng-template #unknown>
          <span>Unknown</span>
        </ng-template>
      </span>
    </div>
  </div>
  <div class="flex-container">
    <form class="editable-details" [formGroup]="formGroup">
      <div class="half-width">
        <label aria-label="Assignee">
          Assignee
        </label>
        <div class="mat-form-field">
          <app-typeahead test-id="user-typeahead" class="solid-background full-width" formControlName="assignee"
            placeholder="Assignee" [options]="users">
          </app-typeahead>
          <mat-error *ngIf="formGroup.controls.assignee.hasError('required')">
            Assignee is required
          </mat-error>
        </div>
      </div>

      <div class="half-width">
        <label aria-label="Date Due">
          Date Due
        </label>
        <mat-form-field appearance="outline" class="date-field flex-field">
          <input test-id="due-date-input" formControlName="dueDate" matInput [matDatepicker]="datepicker"
            placeholder="Select Date" autocomplete="off">
          <mat-datepicker-toggle [for]="datepicker" class="xs" test-id="due-date-picker-toggle">
            <mat-icon matDatepickerToggleIcon class="xs">event</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #datepicker></mat-datepicker>
          <mat-error *ngIf="formGroup.controls.dueDate.hasError('required')">
            Date Due is required.
          </mat-error>
          <mat-error *ngIf="formGroup.controls.dueDate.hasError('pastDate')">
            Date Due must be a future date.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="half-width" *ngIf="!cloneView;">
        <label aria-label="Status">
          Status
        </label>
        <mat-form-field appearance="outline">
          <mat-select test-id="status" formControlName="status">
            <mat-option *ngFor="let status of statusOptions" [value]="status.value">{{ status.display }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="half-width">
        <label aria-label="Task Tags">
          Task Tags
        </label>
        <fw-tags test-id="task-tags" formControlName="tags" [autoSave]="false" [allowCustomTags]="true"
          [container]="tagContainer" [useAsInlineField]="true"></fw-tags>
      </div>
    </form>

    <ng-container *ngIf="!cloneView;">
      <mat-tab-group *ngIf="taskDetails; else loadingState" class="tabs-white content-body" animationDuration="0ms" mat-stretch-tabs="false">
        <mat-tab label="Form Data">
          <ng-template matTabContent>
            <mat-table *ngIf="formData.data.length; else emptyFormData" [dataSource]="formData" class="data-table">
              <ng-container matColumnDef="question">
                <mat-cell *matCellDef="let element">
                  <strong [attr.test-id]="'question-label-' + element.key">{{ element.label }}</strong>
                  <span [attr.test-id]="'question-key-' + element.key" class="grey">{{ element.key }}</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="response">
                <mat-cell *matCellDef="let element">
                  <span [attr.test-id]="'response-label-' + element.key" class="response"
                    [innerHTML]="element.response ? element.response : '-'"></span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="error">
                <mat-cell *matCellDef="let element" colspan="2">
                  <strong
                    test-id="form-data-error-header">See Viewer for Form Data</strong>
                  <span test-id="form-data-error-message"
                    class="grey">There is a slice specific workflow set up for this task. Please launch in viewer to review this data on each slice.</span>
                </mat-cell>
              </ng-container>
              <ng-container *ngIf="!isSliceSpecificWorkflow">
                <mat-row *matRowDef="let element; columns: ['question', 'response']"></mat-row>
              </ng-container>
              <ng-container *ngIf="isSliceSpecificWorkflow">
                <mat-row *matRowDef="let element; columns: ['error']"></mat-row>
              </ng-container>
            </mat-table>
            <ng-template #emptyFormData>
              <div class="empty blank-state">
                <mat-icon class="sm raised blue">search</mat-icon>
                <p>No response data exists for this form.</p>
              </div>
            </ng-template>
          </ng-template>
        </mat-tab>
        <mat-tab label="Annotation Data">
          <ng-template matTabContent>
            <mat-table *ngIf="annotationData.data.length; else emptyAnnotations" [dataSource]="annotationData"
              class="data-table">
              <ng-container matColumnDef="question">
                <mat-cell *matCellDef="let element">
                  <strong [attr.test-id]="'question-label-' + element.key">{{ element.label }}</strong>
                  <span [attr.test-id]="'question-key-' + element.key" class="grey">{{ element.key }}</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="response">
                <mat-cell *matCellDef="let element">
                  <span [attr.test-id]="'response-label-' + element.key"
                    fwTooltip="Count of annotations by label and tool type" class="response"
                    [innerHTML]="element.response ? element.response : '-'"></span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="error">
                <mat-cell *matCellDef="let element" colspan="2">
                  <strong
                    test-id="annotation-data-error-header">See Viewer for Annotation Data</strong>
                  <span test-id="annotation-data-error-message"
                    class="grey">There is a slice specific workflow set up for this task. Please launch in viewer to review this data on each slice.</span>
                </mat-cell>
              </ng-container>
              <ng-container *ngIf="!isSliceSpecificWorkflow">
                <mat-row *matRowDef="let element; columns: ['question', 'response']"></mat-row>
              </ng-container>
              <ng-container *ngIf="isSliceSpecificWorkflow">
                <mat-row *matRowDef="let element; columns: ['error']"></mat-row>
              </ng-container>
            </mat-table>
            <ng-template #emptyAnnotations>
              <div class="empty blank-state">
                <mat-icon class="sm raised blue">search</mat-icon>
                <p>No annotations have been added to this task.</p>
              </div>
            </ng-template>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
      <ng-template #loadingState>
        <div test-id="loading-state" class="blank-state content-body">
          <img src="/assets/images/loading.svg" style="margin-bottom:10px">
          <p>Loading Task Details...</p>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>

<div class="action-buttons" mat-dialog-actions align="end">
  <ng-container *ngIf="!cloneView; else cloneButtons">
    <a test-id="view-related-tasks-link"
      (click)="viewRelatedTasks()">View Related Tasks</a>
    <ng-container *ngIf="isReaderTaskAdmin; else closeButton">
      <button test-id="cancel-button" mat-stroked-button
        mat-dialog-close>Cancel</button>
      <button test-id="delete-button" mat-stroked-button
        (click)="deleteTask()">Delete</button>
      <button test-id="clone-button" mat-stroked-button
        (click)="showCloneView(true)">Clone</button>
      <button test-id="save-button" mat-flat-button color="primary" (click)="submit()"
        [disabled]="formGroup.invalid || !formGroup.dirty">
        Save Changes
      </button>
    </ng-container>
    <ng-template #closeButton>
      <button test-id="close-button" mat-stroked-button
        mat-dialog-close>Close</button>
    </ng-template>
  </ng-container>
  <ng-template #cloneButtons>
    <button test-id="cancel-clone-button" mat-stroked-button
      (click)="showCloneView(false)">Cancel</button>
    <button test-id="clone-button" mat-flat-button color="primary" (click)="createClone()"
      [disabled]="formGroup.invalid">
      Clone
    </button>
  </ng-template>
</div>
